<template>
  <div id="app">
    <md-toolbar class="md-primary">
      <h3 class="md-title" style="flex: 1">Qempo Web Tools</h3>
      <md-menu md-size="big" md-direction="bottom-end">
        <md-button class="md-icon-button" md-menu-trigger>
          <md-icon>account_circle</md-icon>
        </md-button>
        <md-menu-content>
          <md-menu-item @click="authModalPrompt()">
            <span>Log In</span>
            <md-icon>face</md-icon>
          </md-menu-item>
        </md-menu-content>
      </md-menu>
    </md-toolbar>
    <md-tabs router-link>
      <md-tab md-label="Product Crafter" to="/product-crafter">
        <ProductCrafter />
      </md-tab>
      <md-tab md-label="Bag Crafter" to="/bag-crafter">
        <BagCrafter />
      </md-tab>
      <md-tab md-label="Deal Manager" to="/deal-manager">
        <DealManager />
      </md-tab>
    </md-tabs>
    <AuthDialog ref="auth_dialog"/>
  </div>
</template>

<script>
import DealManager from "./components/DealManager";
import BagCrafter from "./components/BagCrafter";
import ProductCrafter from "./components/ProductCrafter";
import AuthDialog from "./components/AuthDialog";

export default {
  name: "app",
  components: {
    BagCrafter,
    DealManager,
    ProductCrafter,
    AuthDialog
  },
  methods: {
    authModalPrompt() {
      this.$refs.auth_dialog.showDialog();
    }
  }
};
</script>

<style>
@import "//fonts.googleapis.com/css?family=Roboto:400,500,700,400italic|Material+Icons";
</style>
